import React, { useState, useEffect } from 'react';
import { fetchQuestion, submitAnswer, createStudySession, storeCompletedQuestion } from '../api/api';
import { useLocation } from 'react-router-dom';
import { useAuth } from '../AuthContext';
import { useContext } from 'react';
import './StudySession.css'

import { useNavigate } from 'react-router-dom';
import './StudySession.css'; // Make sure modal styles are handled here
import { SubscriptionContext } from '../SubscriptionContext';
import QuestionBubble from '../components/QuestionBubble';
import AnswerButtons from '../components/AnswerButtons';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import remarkMath from 'remark-math';
import rehypeKatex from 'rehype-katex';
import 'katex/dist/katex.min.css'; // Import KaTeX CSS


const skillDisplayNameMap = {
  "words_in_context": "Words in Context",
  "text_structure_and_purpose": "Text Structure and Purpose",
  "cross_text_connections": "Cross-Text Connections",
  "central_ideas_and_details": "Central Ideas and Details",
  "command_of_evidence": "Command of Evidence",
  "inferences": "Inferences",
  "boundaries": "Boundaries",
  "form_structure_and_sense": "Form, Structure, and Sense",
  "rhetorical_synthesis": "Rhetorical Synthesis",
  "transitions": "Transitions",

  "linear_equations_in_one_variable": "Linear equations in one variable",
  "linear_equations_in_two_variables": "Linear equations in two variables",
  "linear_functions": "Linear functions",
  "systems_of_two_linear_equations_in_two_variables": "Systems of two linear equations in two variables",
  "linear_inequalities_in_one_or_two_variables": "Linear inequalities in one or two variables",

  "equivalent_expressions": "Equivalent expressions",
  "nonlinear_equations_in_one_variable_and_systems_of_equations_in_two_variables":
    "Nonlinear equations in one variable and systems of equations in two variables",
  "nonlinear_functions": "Nonlinear functions",

  "ratios_rates_proportional_relationships_and_units": "Ratios, rates, proportional relationships, and units",
  "percentages": "Percentages",
  "one_variable_data_distributions_and_measures_of_center_and_spread":
    "One-variable data: distributions and measures of center and spread",
  "two_variable_data_models_and_scatterplots": "Two-variable data: models and scatterplots",
  "probability_and_conditional_probability": "Probability and conditional probability",
  "inference_from_sample_statistics_and_margin_of_error":
    "Inference from sample statistics and margin of error",
  "evaluating_statistical_claims_observational_studies_and_experiments":
    "Evaluating statistical claims: observational studies and experiments",

  "area_and_volume": "Area and volume",
  "lines_angles_and_triangles": "Lines, angles, and triangles",
  "right_triangles_and_trigonometry": "Right triangles and trigonometry",
  "circles": "Circles",
};

const domainDisplayNameMap = {
  "craft_and_structure": "Craft and Structure",
  "information_and_ideas": "Information and Ideas",
  "standard_english_conventions": "Standard English Conventions",
  "expression_of_ideas": "Expression of Ideas",
  "algebra": "Algebra",
  "advanced_math": "Advanced Math",
  "problem_solving_and_data_analysis": "Problem-Solving and Data Analysis",
  "geometry_and_trigonometry": "Geometry and Trigonometry",
};

const StudySession = () => {
  const [showEndModal, setShowEndModal] = useState(false);
  const navigate = useNavigate();
  const [question, setQuestion] = useState(null);
  const [sessionId, setSessionId] = useState(null);
  const [selectedAnswer, setSelectedAnswer] = useState('');
  const [gradingFeedback, setGradingFeedback] = useState(null); // For grading feedback
  const location = useLocation()
  const selectedSkills = location.state?.selectedSkills || [];
  const selectedDifficulty = location.state?.difficulty;
  const selectedMode = location.state?.mode;
  const selectedSection = location.state?.selectedSection;
  const [completedQuestions, setCompletedQuestions] = useState([]);
  const [loading, setLoading] = useState(true); // start with loading true initially
  const [showFreeLimitReachedScreen, setShowFreeLimitReachedScreen] = useState(false);
  const { user } = useAuth();
  const { userSubscription } = useContext(SubscriptionContext);

  // Use a Set to track completed question IDs
  const [completedQuestionIds, setCompletedQuestionIds] = useState(new Set());

  useEffect(() => {
    const startSession = async () => {
      setLoading(true);  // show loading screen
      try {
        const session = await createStudySession("SAT", selectedSection, selectedSkills, selectedDifficulty, selectedMode);
        setSessionId(session.session_id);
        const questionData = await fetchQuestion(session.session_id);
        setQuestion(questionData);
      } finally {
        setLoading(false); // hide loading screen
      }
    };
    startSession();
  }, [selectedSkills]);
/*
  useEffect(() => {
    if (userSubscription && userSubscription.subscription_tier === 'free') {
      const { freeQuestionsUsed, freeQuestionsLimit } = userSubscription;
      if (freeQuestionsUsed >= freeQuestionsLimit) {
        setShowFreeLimitReachedScreen(true);
        setQuestion(null);
        setGradingFeedback(null);
      } else {
        setShowFreeLimitReachedScreen(false);
      }
    } else {
      setShowFreeLimitReachedScreen(false);
    }
  }, [userSubscription]);*/
  useEffect(() => {
    const handleBeforeUnload = (event) => {
        // Cancel the event to prevent the default action
        event.preventDefault();
        // Modern browsers often ignore this and show a generic message
        // but setting the returnValue is good practice for older browsers.
        event.returnValue = 'Are you sure you want to end your study session?'; 
    };

    window.addEventListener('beforeunload', handleBeforeUnload);

    // Cleanup function
    return () => {
        window.removeEventListener('beforeunload', handleBeforeUnload);
    };
}, []);

  const handleAnswer = async (answer) => {
    setSelectedAnswer(answer);
    console.log(sessionId);
    console.log(question.id);
    const result = await submitAnswer(sessionId, question.id, answer);
    console.log(answer);
    console.log(result.correct_answer);
    setGradingFeedback({
      correctAnswer: result.correct_answer,
      explanation: result.explanation,
      isCorrect: result.is_correct
    });

    console.log('Grading result:', result);

    const questionData = {
      question_id: question.id,
      time_completed: new Date().toISOString(),
      is_correct: result.is_correct,
      selected_answer: answer
    };

    // Check if the question has already been completed
    if (!completedQuestionIds.has(question.id)) {
      setCompletedQuestions(prevQuestions => [...prevQuestions, questionData]);
      setCompletedQuestionIds(prevIds => new Set(prevIds.add(question.id))); // Update the Set

      if (user && sessionId) {
        try {
          await storeCompletedQuestion(sessionId, questionData); // Call storeCompletedQuestion
          console.log('Question data sent to backend');
        } catch (error) {
          console.error('Error sending question data to backend:', error);
        }
      } else {
        console.log('User not logged in or session ID not available');
      }
    } else {
      console.log('This question has already been completed.');
    }
  };

  const handleNextQuestion = async () => {
    setGradingFeedback(null);
    setSelectedAnswer('');
    setLoading(true);  // show loading screen

    try {
      const questionData = await fetchQuestion(sessionId);
      setQuestion(questionData);
      userSubscription.free_questions_used += 1;
    } finally {
      setLoading(false);  // hide loading screen
    }
  };

  if (loading) {
    return (
      <div className="loading-screen">
        <p>Loading questions...</p>
        {/* You can add a spinner icon or animation here */}
      </div>
    );
  }


  if (showFreeLimitReachedScreen) {
    return (
      <div className="limit-reached-screen">
        <h2 className="limit-reached-title">Free Question Limit Reached!</h2>
        <p className="limit-reached-message">
          You have used all {userSubscription?.freeQuestionsLimit} free questions.
          Upgrade your plan or join our Beta Launch Program to continue practicing!
        </p>
        <div className="upgrade-options">
            <button
                onClick={() => navigate('/subscription-management')} // Redirect to subscription page
                className="upgrade-button-large"
            >
                Upgrade to Paid Plan
            </button>
            <button
                onClick={() => navigate('/subscription-management')} // Redirect to subscription page
                className="upgrade-button-large premium"
            >
                Join Beta Launch Program
            </button>
        </div>
        <button
          onClick={() => navigate('/dashboard')}
          className="back-to-dashboard-button"
        >
          Back to Dashboard
        </button>
      </div>
    );
  }


  return (
    <div className="study-session-container">
      
      <div className="session-header">
        <div className="session-meta">
          <div className="session-info-bar">
            <span><strong>Domain:</strong> {domainDisplayNameMap[question?.domain]}</span>
            <span><strong>Skill:</strong> {skillDisplayNameMap[question?.skill_category] || question?.skill_category}</span>
            <span><strong>Difficulty:</strong> {question?.difficulty?.[0].toUpperCase() + question?.difficulty?.slice(1)}</span>
          </div>
        </div>
        <button className="end-session-button" onClick={() => setShowEndModal(true)}>
          End Session
        </button>
      </div>
      <QuestionBubble
        question={question.question}
        graphicUrl={question?.graphic_url}
      />

    <AnswerButtons
      options={question?.choices}
      onAnswerClick={handleAnswer}
      />


      {showEndModal && (
        <div className="modal-overlay">
          <div className="modal-content">
            <h3>End Session?</h3>
            <p>Are you sure you want to end the session? You'll be taken to the review page.</p>
            <div className="modal-buttons">
              <button onClick={() => navigate(`/review-session/${sessionId}`)}>Yes, End Session</button>
              <button onClick={() => setShowEndModal(false)}>Cancel</button>
            </div>
          </div>
        </div>
      )}

      {gradingFeedback && (
        <div className="feedback">
          <p>
            {gradingFeedback.isCorrect ? 'Correct! ' : 'Incorrect. '}
            <ReactMarkdown 
                              remarkPlugins={[remarkGfm, remarkMath]}
                              rehypePlugins={[rehypeKatex]}
                              className="markdown-content"
                            >
                              {gradingFeedback.explanation}
                            </ReactMarkdown>
            
          </p>
          <button className="next-question-button" onClick={handleNextQuestion}>
            Next Question
          </button>
        </div>
      )}
    </div>
  );
};

export default StudySession;